import React, { useState, Fragment, useEffect } from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import { chunk } from 'lodash';
import styles from './index.module.css';
import Loader from '../../../../nonFeatureComponents/Loader';
import { archetypesReflectPageDes } from '../../language';
import SkillItem from '../SkillItem';
const SkillsList = ({
  skills,
  extendSkills,
  archetypeName,
  extendArchetypeName,
  loading,
  loadErr
}) => {
  const pageSize = 6;
  const skillListDes = archetypesReflectPageDes.archetypeSkillList;
  const [combineSkills, setCombineSkills] = useState([]);
  const handleSkillChange = newSkill => {
    const skills = combineSkills.map(item => {
      const newReflectedInformation = newSkill.reflectedInformation;
      const oldReflectedInformation = item.reflectedInformation;
      if (item.skillId === newSkill.skillId) {
        return {
          ...item,
          reflectedInformation:
            newReflectedInformation === null
              ? null
              : {
                  ...newReflectedInformation,
                  ...(oldReflectedInformation && {
                    id: oldReflectedInformation.id,
                    skillId: oldReflectedInformation.skillId
                  })
                }
        };
      }
      return item;
    });
    setCombineSkills(skills);
  };

  useEffect(() => {
    let extendSkillsWithTitle = extendSkills.map((el, i) => {
      if (i === 0) el.title = extendArchetypeName;
      return el;
    });
    let skillsWithTitle = skills.map((el, i) => {
      if (i === 0 && extendSkills.length) el.title = archetypeName;
      return el;
    });

    setCombineSkills([...skillsWithTitle, ...extendSkillsWithTitle]);
  }, [extendSkills, skills, archetypeName, extendArchetypeName]);

  return (
    <div className={styles.competenciesList} data-cy="competenciesList">
      <div className={styles.header}>
        <div className={styles.firstColumn}>{skillListDes.firstColumn}</div>
        <div className={clsx(styles.secondColumn)}>
          <div>{skillListDes.secondColumn}</div>
          <div className={styles.suggestedLevel}>
            <div />
            {skillListDes.suggestedLevel}
          </div>
        </div>
        <div className={styles.thirdColumn}>{skillListDes.thirdColumn}</div>
      </div>
      <div className={styles.body} data-cy="competenciesListBody">
        {loadErr && <p className={styles.errorMsg}>{skillListDes.errorMsg}</p>}
        {loading && <Loader />}
        {!loading &&
          !loadErr &&
          chunk(combineSkills, pageSize).map((skillsChunk, i) => (
            <Fragment key={i}>
              {skillsChunk.map(skill => (
                <Fragment key={skill.skillId}>
                  {skill.title && (
                    <div className={styles.archetypeName}>
                      <p
                        className={clsx(styles.firstColumn, styles.groupTitle)}
                      >
                        {skill.title}
                      </p>
                      <p className={styles.secondColumn} />
                      <p className={styles.thirdColumn} />
                    </div>
                  )}
                  <SkillItem onChange={handleSkillChange} skill={skill} />
                </Fragment>
              ))}
            </Fragment>
          ))}
      </div>
    </div>
  );
};

SkillsList.propTypes = {
  skills: PropTypes.array.isRequired,
  extendSkills: PropTypes.array.isRequired,
  archetypeName: PropTypes.string,
  extendArchetypeName: PropTypes.string,
  loading: PropTypes.bool.isRequired,
  loadErr: PropTypes.bool.isRequired
};

export default SkillsList;
